import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Data, RouterModule } from '@angular/router';
import { CwIcon } from '@bbraun/cortex-angular';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { NavigationService } from '~/app/services/navigation.service';

@Component({
  selector: 'gplus-mobile-drawer',
  imports: [CwIcon, TranslateModule, CommonModule, RouterModule],
  templateUrl: './mobile-drawer.component.html',
  styleUrl: './mobile-drawer.component.scss',
  host: {
    'animate.enter': 'slide-in',
    'animate.leave': 'slide-out'
  }
})
export class MobileDrawerComponent {
  public navigationItems: Observable<Array<Data>>;

  constructor(private readonly navigationService: NavigationService) {
    this.navigationItems = this.navigationService.getRoutes();
  }
}
